import { SearchSubRuleFormConfiguration, SearchSubRuleFormData, SearchSubRuleFormValidationData } from '../../../integrated-client/models';

export interface ISearchSubRuleFormData extends SearchSubRuleFormData {}

export interface ISearchSubRuleConfigurationData extends SearchSubRuleFormConfiguration {}

export interface ISearchSubRuleValidationData extends SearchSubRuleFormValidationData {}

export interface ISearchSubRuleEditorData {
  editorData?: ISearchSubRuleFormData;
  configuration?: ISearchSubRuleConfigurationData;
  validation?: ISearchSubRuleValidationData;
}

export class SearchSubRuleEditorData implements ISearchSubRuleEditorData {
  editorData?: ISearchSubRuleFormData;
  validation?: ISearchSubRuleValidationData;
  configuration?: ISearchSubRuleConfigurationData;

  constructor() {
    this.editorData = {};
    this.validation = {};
    this.configuration = {};
  }
}
